import { render } from "./TheBaseLayout.vue?vue&type=template&id=1796b222&scoped=true"
import script from "./TheBaseLayout.vue?vue&type=script&lang=js"
export * from "./TheBaseLayout.vue?vue&type=script&lang=js"

import "./TheBaseLayout.vue?vue&type=style&index=0&id=1796b222&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1796b222"]])

export default __exports__